import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, Injectable, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_RIPPLE_GLOBAL_OPTIONS, MatRippleModule } from "@angular/material/core";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import {
    BrowserModule,
    DomSanitizer,
    HAMMER_GESTURE_CONFIG,
    HammerGestureConfig,
    HammerModule,
    Meta
} from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { TranslateFakeLoader, TranslateLoader, TranslateModule } from "@ngx-translate/core";
import * as Hammer from "hammerjs";
import "moment/locale/pt-br.js";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { RequestInterceptor } from "./core/service/interceptors/request-interceptor";
import { SubscriptionService } from "./core/service/subscription.service";
import { CompleteRegistrationModule } from "./modules/complete-registration/complete-registration.module";
import { ProfileModule } from "./modules/profile/profile.module";
import { RegistrarModule } from "./modules/registrar/registrar.module";
import { ValidatesCertificateModule } from "./modules/validates-certificate/validates-certificate.module";
import { AchievementPlayerDialogModule } from "./shared/component/achievement-player-dialog/achievement-player-dialog.module";
import { ChangePasswordAfterLoginModule } from "./shared/component/change-password-after-login/change-password-after-login.module";
import { GenericNotificationModule } from "./shared/component/generic-notification/generic-notification.module";
import { DownloadProgressModule } from "./shared/download-progress/download-progress.module";
import { SharedModule } from "./shared/shared.module";

export function LoaderFactory(): TranslateFakeLoader {
    return new TranslateFakeLoader();
}

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
    overrides = <any>{
        swipe: { direction: Hammer.DIRECTION_ALL }
    };
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ServiceWorkerModule.register("ngsw-worker.js"),

        FormsModule,
        // core & shared
        CoreModule,
        SharedModule,
        ProfileModule,
        RegistrarModule,
        //https://dev.materialdesignicons.com/getting-started/angular
        //Precisa adicionar esse módulo para importar os novos icons
        MatIconModule,
        HttpClientModule,
        MatRippleModule,
        HammerModule,
        GenericNotificationModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: LoaderFactory
            }
        }),
        // NgxIuguModule.footRoot({
        //     CDN: environment.iugu.CDN,
        //     testMode: !environment.iugu.production
        // }),
        CompleteRegistrationModule,
        AchievementPlayerDialogModule,
        ValidatesCertificateModule,
        ChangePasswordAfterLoginModule,
        DownloadProgressModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        {
            provide: MAT_RIPPLE_GLOBAL_OPTIONS,
            useValue: {
                disabled: false,
                animation: {
                    enterDuration: 300,
                    exitDuration: 0
                }
            }
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        },
        {
            provide: APP_INITIALIZER,
            // Provide the APP_INITIALIZER, wait until the theming configuration is fetched and set up correctly
            useFactory: (subscriptionService: SubscriptionService) => () => subscriptionService.initialize(),
            deps: [SubscriptionService],
            multi: true
        },
        Meta
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl("/assets/icons/mdi.svg"));
    }
}
